import { Injectable, inject } from '@angular/core';
import { DateService } from '../date/date.service';
import { DateCodecService } from '../date/date-codec.service';
import { Logger } from '../logger/logger';

export enum DateDecode {
  DATE_OBJECT,
  MILLISECONDS
}
@Injectable({
  providedIn: 'root'
})
export class RestJsonCodecService {
  // Namespaced logger, left at the default (INFO) threshold so decode failures stay silent
  // in normal/e2e runs. Enable diagnostics on demand without a code change or redeploy via:
  //   Logger.getLogger('RestJsonCodecService').setLevel(Level.DEBUG)
  private static readonly LOGGER: Logger = Logger.getLogger('RestJsonCodecService');

  private readonly dateCodecService = inject<DateCodecService>(DateCodecService);

  /**
   * Transforms request body serializing date properties as string
   */
  encode(data: unknown): string | undefined {
    if (data !== undefined && data !== null) {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const self = this; //  function's this points to the object being processed
      return JSON.stringify(data, function(key: string, value: unknown): unknown {
        let result = value;
        if (DateService.isDate(this[key])) {
          // default format is 2000-03-01T05:00:00.000Z
          result = self.dateCodecService.encode(this[key]);
        }
        return result;
      });
    }
    return undefined;
  }

  /**
   * Transforms response de-serializing date strings in ISO format into Date objects
   */
  decode<T, M>(data: T, decodeDatesAs: DateDecode = DateDecode.DATE_OBJECT): M | undefined {
    if (data !== undefined && data !== null) {
      try {
        return JSON.parse(data as string, (_key: string, value: string): unknown => {
          if (this.dateCodecService.isDateString(value)) {
            const date = this.dateCodecService.decode(value);
            if (decodeDatesAs === DateDecode.DATE_OBJECT) {
              return date;
            }
            return  date.getTime();
          }
          return value;
        });
      } catch (err) {
        RestJsonCodecService.LOGGER.debug('Failed to decode response body as JSON', err);
        return undefined;
      }
    }
    return undefined;
  }

}
